import { useCepStore } from '../stores/useCepStore';
import { isValidCEP } from './ValidateCEP';

type UseCepValidatorReturn = {
  validarCep: (cep: string) => Promise<boolean>;
};

export function useCepValidator(): UseCepValidatorReturn {
  const setCep = useCepStore(x => x.setCepVia);

  const validarCep = async (cep: string): Promise<boolean> => {
    const { valido, viaCepUsado } = await isValidCEP(cep);

    if (valido) {
      setCep(viaCepUsado);
    }

    return valido;
  };

  return { validarCep };
}
